export default "__VITE_PUBLIC_ASSET__03de23d0__"